<div class="affected-service-item">
  @if (isAccessible()) {
    <a
      class="no-style-link affected-service-item__icon-link"
      [routerLink]="routerLink()"
      [state]="linkState()"
      (click)="emitClick($event)"
    >
      <service-icon size="m" [type]="iconType()" />
    </a>
  } @else {
    <service-icon size="m" [type]="iconType()" />
  }

  <div class="affected-service-item__caption">
    <div class="affected-service-item__title">
      <div>
        @if (isAccessible()) {
          <a class="no-style-link" [routerLink]="routerLink()" [state]="linkState()" (click)="emitClick($event)">{{
            description()
          }}</a>
        } @else {
          {{ description() }}
        }
      </div>
    </div>
    <div class="affected-service-item__subtitle">
      @if (isAccessible()) {
        <service-id [subscriptionId]="subscriptionId()" />
        <span>{{ impact() | cim_impact_type }}</span>
      } @else {
        {{ "Global.NoAccessContact" | translate }} {{ displayName() }}
      }
    </div>
  </div>
  @if (isAccessible()) {
    <a class="no-style-link" [routerLink]="routerLink()" [state]="linkState()" (click)="emitClick($event)">
      <svg-icon class="affected-service-item__arrow" src="assets/images/icons/arrow-small-right.svg"></svg-icon>
    </a>
  } @else {
    <svg-icon class="affected-service-item__lock" src="assets/images/icons/lock.svg"> </svg-icon>
  }
</div>
